import useIsTransparent from '@/hooks/useIsTransparent';
import React from 'react'
import AppModal from './AppModal';
import { WarningIcon } from '@/app/login/Icons';
import { colors } from '../../tailwind.config';
import Button from './Button';
import { useUserContext } from '@/Context/UserContext';
import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';

interface Props {
  onClose: () => void
}

export default function LogoutModal({ onClose }: Props) {
  const { isTransparent, onCloseClicked } = useIsTransparent();
  const { setUser } = useUserContext();
  const queryClient = useQueryClient();
  const { replace } = useRouter();

  const logout = () => {
    setUser(null);
    localStorage.removeItem('@privateKey');
    localStorage.removeItem('@pubKey');
    localStorage.removeItem('@accessToken');
    localStorage.removeItem('@user');
    queryClient.clear();
    onCloseClicked();
    replace("/");

  }

  return (
    <AppModal title={"تسجيل خروج"} onClose={onClose} isTransparent={isTransparent} onCloseClicked={onCloseClicked}>
      <div className="p-4 md:p-5 space-y-4">
        <div className="w-20 aspect-auto mx-auto">
          <WarningIcon size={80} color={colors.black.base} />
        </div>
        <div className={["text-center", "text-black-base"].join(" ")}>
          {"سوف نفتقدك، نتمنى أن نراك في وقت قريب"}
        </div>
      </div>
      <div className="flex items-center justify-center p-4 md:p-5 border-t border-gray-200 rounded-b gap-2">
      <Button
          onClick={onCloseClicked}
          className={["min-w-20 px-5 py-2.5 text-sm font-medium"].join(" ")}
          variant={"secondary"}
        >
          {"إلغاء"}
        </Button>
        <Button
          onClick={logout}
          className={["min-w-20 px-5 py-2.5 text-sm font-medium", "!bg-red-base"].join(" ")}
        >
          {"تسجيل خروج"}
        </Button>
      
      </div>
    </AppModal>
  )
}
